var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 132,
    viewBox: "0 0 120 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_295_1100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 41.833V61.6663M50 61.6663H46.5M50 61.6663H53.5",
    stroke: "#00A63E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4993 51.1663L57.5827 45.333L54.666 51.1663",
    stroke: "#00A63E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 51.1663L42.4167 45.333L39.5 51.1663",
    stroke: "#00A63E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.666 45.333H41.8889C43.363 45.333 44.7931 44.7158 45.9441 43.583C48.3149 41.2497 51.6838 41.2497 54.0546 43.583C55.2056 44.7158 56.6357 45.333 58.1098 45.333H59.3327",
    stroke: "#00A63E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5833 55.8337C59.1638 55.8337 60.5401 54.861 61.2552 53.4244C61.641 52.6489 61.834 52.2612 61.4817 51.7142C61.1295 51.167 60.5467 51.167 59.3808 51.167H55.7858C54.62 51.167 54.0371 51.167 53.6849 51.7142C53.3327 52.2612 53.5257 52.6489 53.9115 53.4244C54.6265 54.861 56.0028 55.8337 57.5833 55.8337Z",
    stroke: "#00A63E",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4173 55.8337C43.9978 55.8337 45.3741 54.861 46.0891 53.4244C46.475 52.6489 46.6679 52.2612 46.3157 51.7142C45.9635 51.167 45.3807 51.167 44.2149 51.167H40.6198C39.454 51.167 38.8711 51.167 38.5189 51.7142C38.1667 52.2612 38.3596 52.6489 38.7455 53.4244C39.4605 54.861 40.8368 55.8337 42.4173 55.8337Z",
    stroke: "#00A63E",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 40.083C51.75 41.0495 50.9665 41.833 50 41.833C49.0335 41.833 48.25 41.0495 48.25 40.083C48.25 39.1165 49.0335 38.333 50 38.333C50.9665 38.333 51.75 39.1165 51.75 40.083Z",
    stroke: "#00A63E",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_295_1100",
    x: -20,
    y: -8,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_1100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_295_1100",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.5c0f096383bcf179379c987df0874344.svg";
export { ForwardRef as ReactComponent };